{% block uc_media_upload %}
<div class="uc-media-upload">

    <label v-if="label" class="uc-media-upload__label">{{ label }}</label>

    {# The Choose/Remove buttons below are disabled whenever this field is
       currently INHERITING the "All Sales Channels" value (Shopware's
       standard per-sales-channel override lock — the same mechanism every
       built-in field type uses, driven by the `disabled` prop the config
       framework passes in). Without this hint the greyed-out buttons alone
       look like a bug ("I picked a sales channel and now I can't change the
       image") rather than "click the link icon above to un-inherit first" —
       this banner makes that explicit instead of relying on the merchant
       noticing the small inheritance-switch icon next to the field label. #}
    <p v-if="disabled" class="uc-media-upload__inherited-hint">
        {{ $tc('sellops-ultimate-cart.mediaUpload.inheritedHint') }}
    </p>

    <div class="uc-media-upload__body">

        {# Preview of the selected image #}
        <div v-if="mediaEntity" class="uc-media-upload__preview">
            <img
                v-if="previewUrl"
                :src="previewUrl"
                :alt="fileName"
                class="uc-media-upload__img"
            >
            <span class="uc-media-upload__filename">{{ fileName }}</span>
        </div>

        {# No merchant-uploaded image yet — show the plugin's built-in default
           icon as a preview (never saved as the actual value) so the popup
           shows the same image shoppers will actually see on the storefront
           until the merchant replaces it. #}
        <div v-else-if="showDefaultPreview" class="uc-media-upload__preview uc-media-upload__preview--default">
            <img
                :src="defaultPreviewUrl"
                :alt="$tc('sellops-ultimate-cart.mediaUpload.defaultLabel')"
                class="uc-media-upload__img"
            >
            <span class="uc-media-upload__filename uc-media-upload__filename--default">
                {{ $tc('sellops-ultimate-cart.mediaUpload.defaultLabel') }}
            </span>
        </div>

        <div v-else class="uc-media-upload__empty">
            {{ $tc('sellops-ultimate-cart.mediaUpload.emptyLabel') }}
        </div>

        <div class="uc-media-upload__actions">
            <sw-button
                size="small"
                :disabled="disabled"
                @click="showMediaModal = true"
            >
                {{ $tc('sellops-ultimate-cart.mediaUpload.chooseButton') }}
            </sw-button>

            <sw-button
                v-if="mediaEntity"
                size="small"
                :disabled="disabled"
                @click="removeMedia"
            >
                {{ $tc('sellops-ultimate-cart.mediaUpload.removeButton') }}
            </sw-button>
        </div>

    </div>

    <p v-if="showDefaultPreview" class="uc-media-upload__help uc-media-upload__help--default">
        {{ $tc('sellops-ultimate-cart.mediaUpload.defaultHint') }}
    </p>

    <p v-if="helpText" class="uc-media-upload__help">{{ helpText }}</p>

    {# Media library modal — upload or pick, no popover involved #}
    <sw-media-modal-v2
        v-if="showMediaModal"
        :allow-multi-select="false"
        @media-modal-selection-change="onMediaSelectionChange"
        @modal-close="showMediaModal = false"
    />

</div>
{% endblock %}
